import axios from "axios";
import { newApiBaseUrl } from "../../axiosInstance";

const supplierHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `bearer ${localStorage.jwtToken}`,
  "X-Tenant": "hamazon",
});

const asSupplierList = (data) => {
  if (Array.isArray(data)) return data;
  if (data && typeof data === "object") {
    if (Array.isArray(data.suppliers)) return data.suppliers;
    if (Array.isArray(data.items)) return data.items;
  }
  return [];
};

/** TCS suppliers, shaped for the product-settings supplier select. */
export const getSuppliers = async () => {
  const response = await axios.get(`${newApiBaseUrl}/suppliers`, {
    headers: supplierHeaders(),
  });

  return asSupplierList(response.data)
    .map((supplier) => {
      const id = supplier?.supplierId || supplier?.id;
      const name = supplier?.name;
      if (!id || !name) return null;
      return { id: String(id), name: String(name) };
    })
    .filter(Boolean);
};

export const createSupplier = async (name) => {
  const trimmed = String(name || "").trim();
  const response = await axios.post(
    `${newApiBaseUrl}/suppliers`,
    { name: trimmed },
    { headers: supplierHeaders() },
  );
  return { id: String(response.data?.supplierId), name: trimmed };
};

export const updateSupplier = (supplierId, name) =>
  axios.patch(
    `${newApiBaseUrl}/suppliers/${supplierId}`,
    { name: String(name || "").trim() },
    { headers: supplierHeaders() },
  );

/** TCS also deletes the supplier's contacts; it does not check product references. */
export const deleteSupplier = (supplierId) =>
  axios.delete(`${newApiBaseUrl}/suppliers/${supplierId}`, {
    headers: supplierHeaders(),
  });
